import { g as getPhonePrefix, h as getPhoneMask, t as ALL_COUNTRIES } from "./Geo-ImtCGLNH.js";
import { forwardRef, useCallback, useEffect, useRef } from "react";
import { first } from "lodash-es";
import { jsx } from "react/jsx-runtime";
//#region ../../../node_modules/.pnpm/react-text-mask-modern@1.0.4_react@18.3.1/node_modules/react-text-mask-modern/dist/index.mjs
var defaultArray = [];
var emptyString = "";
function adjustCaretPosition({ previousConformedValue = emptyString, previousPlaceholder = emptyString, currentCaretPosition = 0, conformedValue, rawValue, placeholderChar: placeholderChar2, placeholder, indexesOfPipedChars = defaultArray, caretTrapIndexes = defaultArray }) {
	if (currentCaretPosition === 0 || !rawValue.length) return 0;
	const rawValueLength = rawValue.length;
	const previousConformedValueLength = previousConformedValue.length;
	const placeholderLength = placeholder.length;
	const conformedValueLength = conformedValue.length;
	const editLength = rawValueLength - previousConformedValueLength;
	const isAddition = editLength > 0;
	if (editLength > 1 && !isAddition && !(previousConformedValueLength === 0)) return currentCaretPosition;
	const possiblyHasRejectedChar = isAddition && (previousConformedValue === conformedValue || conformedValue === placeholder);
	let startingSearchIndex = 0;
	let trackRightCharacter = false;
	let targetChar;
	if (possiblyHasRejectedChar) startingSearchIndex = currentCaretPosition - editLength;
	else {
		const normalizedConformedValue = conformedValue.toLowerCase();
		const intersection = rawValue.toLowerCase().substring(0, currentCaretPosition).split(emptyString).filter((char) => normalizedConformedValue.indexOf(char) !== -1);
		targetChar = intersection[intersection.length - 1];
		const previousLeftMaskChars = previousPlaceholder.substring(0, intersection.length).split(emptyString).filter((char) => char !== placeholderChar2).length;
		const maskLengthChanged = placeholder.substring(0, intersection.length).split(emptyString).filter((char) => char !== placeholderChar2).length !== previousLeftMaskChars;
		const targetIsMaskMovingLeft = previousPlaceholder[intersection.length - 1] !== void 0 && placeholder[intersection.length - 2] !== void 0 && previousPlaceholder[intersection.length - 1] !== placeholderChar2 && previousPlaceholder[intersection.length - 1] !== placeholder[intersection.length - 1] && previousPlaceholder[intersection.length - 1] === placeholder[intersection.length - 2];
		if (!isAddition && (maskLengthChanged || targetIsMaskMovingLeft) && previousLeftMaskChars > 0 && placeholder.indexOf(targetChar) > -1 && rawValue[currentCaretPosition] !== void 0) {
			trackRightCharacter = true;
			targetChar = rawValue[currentCaretPosition];
		}
		const countTargetCharInPipedChars = indexesOfPipedChars.map((index) => normalizedConformedValue[index]).filter((c) => c === targetChar).length;
		const countTargetCharInIntersection = intersection.filter((c) => c === targetChar).length;
		const requiredNumberOfMatches = placeholder.substring(0, placeholder.indexOf(placeholderChar2)).split(emptyString).filter((char, index) => char === targetChar && rawValue[index] !== char).length + countTargetCharInIntersection + countTargetCharInPipedChars + (trackRightCharacter ? 1 : 0);
		let numberOfEncounteredMatches = 0;
		for (let i = 0; i < conformedValueLength; i++) {
			const conformedValueChar = normalizedConformedValue[i];
			startingSearchIndex = i + 1;
			if (conformedValueChar === targetChar) numberOfEncounteredMatches++;
			if (numberOfEncounteredMatches >= requiredNumberOfMatches) break;
		}
	}
	if (isAddition) {
		let lastPlaceholderChar = startingSearchIndex;
		for (let i = startingSearchIndex; i <= placeholderLength; i++) {
			if (placeholder[i] === placeholderChar2) lastPlaceholderChar = i;
			if (placeholder[i] === placeholderChar2 || caretTrapIndexes.indexOf(i) !== -1 || i === placeholderLength) return lastPlaceholderChar;
		}
	} else if (trackRightCharacter) {
		for (let i = startingSearchIndex - 1; i >= 0; i--) if (conformedValue[i] === targetChar || caretTrapIndexes.indexOf(i) !== -1 || i === 0) return i;
	} else for (let i = startingSearchIndex; i >= 0; i--) if (placeholder[i - 1] === placeholderChar2 || caretTrapIndexes.indexOf(i) !== -1 || i === 0) return i;
	return currentCaretPosition;
}
var placeholderChar = "_";
function convertMaskToPlaceholder(mask = [], placeholderChar2 = placeholderChar) {
	if (!isArray$1(mask)) throw new Error("Text-mask: convertMaskToPlaceholder; The mask must be an array.");
	if (mask.includes(placeholderChar2)) throw new Error(`Placeholder character must not be used inside the mask.

Received placeholder: ${JSON.stringify(placeholderChar2)}
Received mask: ${JSON.stringify(mask)}`);
	return mask.map((char) => char instanceof RegExp ? placeholderChar2 : char).join("");
}
function isArray$1(value) {
	return Array.isArray(value);
}
function isString$1(value) {
	return typeof value === "string" || value instanceof String;
}
function isNumber(value) {
	return typeof value === "number" && !isNaN(value);
}
var strCaretTrap = "[]";
function processCaretTraps(mask) {
	const indexes = [];
	const resultMask = [];
	mask.forEach((item, index) => {
		if (item === strCaretTrap) indexes.push(index);
		else resultMask.push(item);
	});
	return {
		maskWithoutCaretTraps: resultMask,
		indexes
	};
}
var emptyString2 = "";
function conformToMask(rawValue = emptyString2, mask, config = {}) {
	if (!isArray$1(mask)) if (typeof mask === "function") {
		const result = mask(rawValue, config);
		if (result === false) return {
			conformedValue: rawValue,
			meta: { someCharsRejected: false }
		};
		mask = processCaretTraps(result).maskWithoutCaretTraps;
	} else throw new Error("Text-mask: conformToMask; The mask must be an array or a function.");
	const { guide = true, previousConformedValue = emptyString2, placeholderChar: placeholderChar2 = placeholderChar, placeholder = convertMaskToPlaceholder(mask, placeholderChar2), currentCaretPosition, keepCharPositions } = config;
	const suppressGuide = guide === false && previousConformedValue !== void 0;
	const rawValueLength = rawValue.length;
	const previousConformedValueLength = previousConformedValue.length;
	const placeholderLength = placeholder.length;
	const maskLength = mask.length;
	const editDistance = rawValueLength - previousConformedValueLength;
	const isAddition = editDistance > 0;
	const indexOfFirstChange = typeof currentCaretPosition === "number" ? currentCaretPosition + (isAddition ? -editDistance : 0) : 0;
	const indexOfLastChange = indexOfFirstChange + Math.abs(editDistance);
	if (keepCharPositions === true && !isAddition) {
		let compensatingPlaceholderChars = "";
		for (let i = indexOfFirstChange; i < indexOfLastChange; i++) if (placeholder[i] === placeholderChar2) compensatingPlaceholderChars += placeholderChar2;
		rawValue = rawValue.slice(0, indexOfFirstChange) + compensatingPlaceholderChars + rawValue.slice(indexOfFirstChange);
	}
	const rawValueArr = rawValue.split("").map((char, i) => ({
		char,
		isNew: i >= indexOfFirstChange && i < indexOfLastChange
	}));
	for (let i = rawValueLength - 1; i >= 0; i--) {
		const { char } = rawValueArr[i];
		if (char !== placeholderChar2) {
			if (char === placeholder[i >= indexOfFirstChange && previousConformedValueLength === maskLength ? i - editDistance : i]) rawValueArr.splice(i, 1);
		}
	}
	let conformedValue = "";
	let someCharsRejected = false;
	placeholderLoop: for (let i = 0; i < placeholderLength; i++) {
		const charInPlaceholder = placeholder[i];
		if (charInPlaceholder === placeholderChar2) {
			if (rawValueArr.length > 0) while (rawValueArr.length > 0) {
				const { char: rawValueChar, isNew } = rawValueArr.shift();
				if (rawValueChar === placeholderChar2 && suppressGuide !== true) {
					conformedValue += placeholderChar2;
					continue placeholderLoop;
				} else if (mask[i].test(rawValueChar)) {
					if (keepCharPositions !== true || isNew === false || previousConformedValue === emptyString2 || guide === false || !isAddition) conformedValue += rawValueChar;
					else {
						const rawValueArrLength = rawValueArr.length;
						let indexOfNextAvailablePlaceholderChar = null;
						for (let j = 0; j < rawValueArrLength; j++) {
							const charData = rawValueArr[j];
							if (charData.char !== placeholderChar2 && charData.isNew === false) break;
							if (charData.char === placeholderChar2) {
								indexOfNextAvailablePlaceholderChar = j;
								break;
							}
						}
						if (indexOfNextAvailablePlaceholderChar !== null) {
							conformedValue += rawValueChar;
							rawValueArr.splice(indexOfNextAvailablePlaceholderChar, 1);
						} else i--;
					}
					continue placeholderLoop;
				} else someCharsRejected = true;
			}
			if (!suppressGuide) conformedValue += placeholder.slice(i);
			break;
		} else conformedValue += charInPlaceholder;
	}
	if (suppressGuide && !isAddition) {
		let indexOfLastFilledPlaceholderChar = null;
		for (let i = 0; i < conformedValue.length; i++) if (placeholder[i] === placeholderChar2) indexOfLastFilledPlaceholderChar = i;
		conformedValue = indexOfLastFilledPlaceholderChar !== null ? conformedValue.slice(0, indexOfLastFilledPlaceholderChar + 1) : "";
	}
	return {
		conformedValue,
		meta: { someCharsRejected }
	};
}
var emptyString3 = "";
var strNone = "none";
var strObject = "object";
var isAndroid = typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);
var defer = (cb) => {
	if (typeof requestAnimationFrame !== "undefined") requestAnimationFrame(cb);
	else setTimeout(cb, 0);
};
function createTextMaskInputElement(config) {
	const state = {
		previousConformedValue: void 0,
		previousPlaceholder: void 0
	};
	return {
		state,
		update(rawValue, { inputElement, mask: providedMask, guide, pipe, placeholderChar: placeholderChar2 = placeholderChar, keepCharPositions = false, showMask = false } = config) {
			if (typeof rawValue === "undefined") rawValue = inputElement?.value;
			if (rawValue === state.previousConformedValue) return;
			if (typeof providedMask === strObject && providedMask.pipe !== void 0 && providedMask.mask !== void 0) {
				pipe = providedMask.pipe;
				providedMask = providedMask.mask;
			}
			let mask = providedMask;
			let placeholder;
			let caretTrapIndexes;
			if (Array.isArray(mask)) placeholder = convertMaskToPlaceholder(mask, placeholderChar2);
			else if (typeof mask === "function") {
				const evaluatedMask = mask(getSafeRawValue(rawValue), {
					currentCaretPosition: inputElement?.selectionEnd,
					previousConformedValue: state.previousConformedValue,
					placeholderChar: placeholderChar2
				});
				if (evaluatedMask === false) return;
				const { maskWithoutCaretTraps, indexes } = processCaretTraps(evaluatedMask);
				mask = maskWithoutCaretTraps;
				caretTrapIndexes = indexes;
				placeholder = convertMaskToPlaceholder(mask, placeholderChar2);
			}
			if (mask === false) return;
			const safeRawValue = getSafeRawValue(rawValue);
			const currentCaretPosition = inputElement?.selectionEnd ?? 0;
			const { previousConformedValue, previousPlaceholder } = state;
			const conformToMaskConfig = {
				previousConformedValue,
				guide,
				placeholderChar: placeholderChar2,
				pipe,
				placeholder,
				currentCaretPosition,
				keepCharPositions
			};
			const { conformedValue } = conformToMask(safeRawValue, mask, conformToMaskConfig);
			let finalConformedValue = conformedValue;
			let indexesOfPipedChars = [];
			if (typeof pipe === "function") {
				let pipeResult = pipe(conformedValue, {
					rawValue: safeRawValue,
					...conformToMaskConfig
				});
				if (pipeResult === false) pipeResult = {
					value: previousConformedValue || "",
					rejected: true
				};
				else if (isString$1(pipeResult)) pipeResult = { value: pipeResult };
				finalConformedValue = pipeResult.value;
				indexesOfPipedChars = pipeResult.indexesOfPipedChars || [];
			}
			const adjustedCaretPosition = adjustCaretPosition({
				previousConformedValue,
				previousPlaceholder,
				conformedValue: finalConformedValue,
				placeholder: placeholder ?? "",
				rawValue: safeRawValue,
				currentCaretPosition,
				placeholderChar: placeholderChar2,
				indexesOfPipedChars,
				caretTrapIndexes: caretTrapIndexes || []
			});
			const inputElementValue = finalConformedValue === placeholder && adjustedCaretPosition === 0 ? showMask ? placeholder ?? "" : emptyString3 : finalConformedValue;
			state.previousConformedValue = inputElementValue;
			state.previousPlaceholder = placeholder;
			if (!inputElement || inputElement.value === inputElementValue) return;
			inputElement.value = inputElementValue;
			safeSetSelection(inputElement, adjustedCaretPosition || 0);
		}
	};
}
function safeSetSelection(element, position) {
	if (document.activeElement === element) {
		const cb = () => element.setSelectionRange(position, position, strNone);
		if (isAndroid) defer(cb);
		else element.setSelectionRange(position, position, strNone);
	}
}
function getSafeRawValue(value) {
	if (isString$1(value)) return value;
	if (isNumber(value)) return String(value);
	if (value === void 0 || value === null) return emptyString3;
	throw new Error(`The 'value' provided to Text Mask needs to be a string or a number. Received: ${JSON.stringify(value)}`);
}
forwardRef(({ mask, guide, value, pipe, placeholderChar: placeholderChar2, keepCharPositions, showMask, onBlur, onChange, ...rest }, ref) => {
	const localRef = useRef(null);
	const inputRef = ref ?? localRef;
	const textMaskRef = useRef(null);
	const initTextMask = useCallback(() => {
		if (!inputRef.current) return;
		textMaskRef.current = createTextMaskInputElement({
			inputElement: inputRef.current,
			mask,
			guide,
			pipe,
			placeholderChar: placeholderChar2,
			keepCharPositions,
			showMask
		});
		textMaskRef.current.update(value);
	}, [
		mask,
		guide,
		pipe,
		placeholderChar2,
		keepCharPositions,
		showMask,
		value
	]);
	useEffect(() => {
		initTextMask();
	}, [initTextMask]);
	const handleChange = (event) => {
		textMaskRef.current?.update();
		onChange?.(event);
	};
	const handleBlur = (event) => {
		onBlur?.(event);
	};
	return /* @__PURE__ */ jsx("input", {
		ref: (el) => {
			localRef.current = el;
			if (typeof ref === "function") ref(el);
			else if (ref) ref.current = el;
		},
		onBlur: handleBlur,
		onChange: handleChange,
		value,
		...rest
	});
});
//#endregion
//#region src/Phone/utils.ts
var E164_REGEX = /^\+(1|2(?:0|1[12368]|2\d|3\d|4\d|5[0-8]|6\d|7|9[01789])|3(?:[0-4]|5\d|6|7[0-8]|8[0125679]|9)|4(?:0|1|2[013]|[3-9])|5(?:0\d|[1-8]|9\d)|6(?:[0-6]|7[023456789]|8[012356789]|9[012])|7|8(?:0[08]|1|2|4|5[02356]|6|7[08]|8[012368])|9(?:[0-4]|5|6[0-8]|7[012345679]|8|9[234568]))(\d+)(?:;ext=(\d+))?$/;
var getFormattedE164Number = (e164Match) => {
	const [, country, number, extension] = e164Match;
	let formattedNumber;
	if (country === "1" && number?.length === 10) formattedNumber = `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
	else formattedNumber = `+${country} ${number}`;
	if (extension) formattedNumber += ` ext. ${extension}`;
	return formattedNumber;
};
/**
* Converts a telephone number integer value into
* (xxx) xxx-xxxx or +xx xxxxxxx
*
* @param telephoneNumber - The telephone number to format. Accepts string or object types.
*/
var formatPhoneNumber = (telephoneNumber) => {
	if (!telephoneNumber) return "";
	let number;
	let extension;
	let formattedNumber;
	if (isInstanceOfIPhoneNumber(telephoneNumber)) {
		number = telephoneNumber.national_number;
		if (!number) return "";
		const prefix = getPhonePrefix(telephoneNumber.country);
		extension = telephoneNumber.extension;
		formattedNumber = prefix + number;
		if (extension) formattedNumber += `;ext=${extension}`;
	} else formattedNumber = telephoneNumber;
	const e164Match = E164_REGEX.exec(formattedNumber);
	if (e164Match) return getFormattedE164Number(e164Match);
	const value = formattedNumber.toString().trim().replace(/[\+\-()\s]/g, "");
	if (value.match(/[^0-9]/)) return formattedNumber;
	let city;
	switch (value.length) {
		case 10:
			city = value.slice(0, 3);
			number = value.slice(3);
			break;
		case 11:
			city = value.slice(1, 4);
			number = value.slice(4);
			break;
		default: return formattedNumber;
	}
	number = `${number.slice(0, 3)}-${number.slice(3)}`;
	const formattedNumberWithCity = `(${city}) ${number}`.trim();
	if (extension) return `${formattedNumberWithCity} ext. ${extension}`;
	return formattedNumberWithCity;
};
/**
* FIXME: Short-term replacement for default PhoneNumber constructor as
* we migrate from models to interfaces. We should review how it's used
* and determine if this is really needed or if components should be
* adjusted to handle optionally present phone numbers.
*/
function getDefaultPhoneNumber() {
	return {
		country: "US",
		national_number: "",
		extension: ""
	};
}
/**
* This utility function is needed to check types before serializing `IPhoneNumber`
* to string.
*/
function isInstanceOfIPhoneNumber(object) {
	return typeof object === "object" && object !== null && "country" in object && "national_number" in object;
}
function parsePhoneNumber(phoneNumber) {
	let formattedPhoneNumber = typeof phoneNumber === "string" ? phoneNumber.trim() : "";
	if (formattedPhoneNumber && !formattedPhoneNumber.startsWith("+")) formattedPhoneNumber = `+1${formattedPhoneNumber}`;
	let phoneCountry = "US";
	let phonePrefix = "";
	let phoneNatlNumber = "";
	let phoneExtension = "";
	const countryIsUS = formattedPhoneNumber.startsWith("+1");
	const matched = E164_REGEX.exec(formattedPhoneNumber);
	if (matched) {
		[, phonePrefix = "", phoneNatlNumber = "", phoneExtension] = matched;
		const matchedCountryPrefix = `+${phonePrefix}`;
		phoneCountry = first(ALL_COUNTRIES.filter((country) => getPhonePrefix(country) === matchedCountryPrefix)) || "US";
	}
	if (countryIsUS) phoneCountry = "US";
	return {
		country: phoneCountry,
		national_number: phoneNatlNumber,
		extension: phoneExtension
	};
}
function formatAsE164(phoneNumber) {
	return `${getPhonePrefix(phoneNumber.country)}${phoneNumber.national_number}${phoneNumber.extension ? `;ext=${phoneNumber.extension}` : ""}`;
}
var MASK_DEFINITIONS = { "9": /\d/ };
/**
* Converts mask definitions from `ui-mask` style used in python formatting to `text-mask` style
* used in react-text-mask formatting.
*
* For example:
*
* `uiMaskToTextMask('(999) 999-9999')` returns
* `["(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]`
*/
function uiMaskToTextMask(uiMask) {
	return Array.from(uiMask).map((c) => MASK_DEFINITIONS[c] ?? c);
}
/**
* Format phone number with optional country mask.
* For example: Great Britain number would be formatted as `+44 02071838750`
* @param phoneNumber object
* @returns formatted phone number
*/
function formatPhoneNumberWithMask(phoneNumber) {
	const countryPhoneMask = getPhoneMask(phoneNumber.country);
	const mask = countryPhoneMask ? uiMaskToTextMask(countryPhoneMask) : void 0;
	const prefix = getPhonePrefix(phoneNumber.country);
	const maskedContent = mask ? conformToMask(phoneNumber.national_number, mask).conformedValue : phoneNumber.national_number;
	if (!prefix) return maskedContent;
	return `${prefix} ${maskedContent}`;
}
//#endregion
//#region src/Phone/test-utils.ts
function PhoneNumberFactory(extraProps) {
	return {
		country: "US",
		national_number: "9876543210",
		...extraProps
	};
}
//#endregion
export { getDefaultPhoneNumber as a, formatPhoneNumberWithMask as i, formatAsE164 as n, isInstanceOfIPhoneNumber as o, formatPhoneNumber as r, parsePhoneNumber as s, PhoneNumberFactory as t };

//# sourceMappingURL=Phone-C4IoHCot.js.map